import React, { Component } from 'react';
//import logo from './logo.svg';
import { connect } from 'react-redux'
import { initLocation } from './actions'

//import { Row } from 'react-materialize';


class Contact extends Component {
  constructor(props){
    super(props)
    this.state = {
      country: '' ,
      searchico: false,
      searchmovile: false,
      urlsend:'',
      redirect:false,
      optionsli:{
        hover: false,
        closeOnClick: false,
        constrainWidth : true,
        alignment: 'right',
        draggable: true
      },
    }
  }

  componentDidMount(){
    if(this.props.countryinit !== this.state.country){
      this.setState({
        country: this.props.countryinit
      });
    }
  }

  componentWillReceiveProps(next_props) {
    if(next_props.country.location !== this.state.country){
      if(next_props.country.location !== undefined || next_props.country.location !== 'undefined'){
        let stringGeo = (next_props.country.location)?next_props.country.location.toLowerCase():''
        this.setState({
          country: stringGeo
        });
      }
    }

    if(next_props.search !== this.state.searchico){
      this.setState({
        searchico: next_props.search
      });
    }

  }

  render() {
      if(this.state.country === 'ar'){
        return (
          <div>
            <a href="/quienes-somos/">Quienes Somos</a>
            <a href="/contacto-argentina/">Contacto</a>
          </div>
        );
      }
      if(this.state.country === 'co'){
        return (
          <div>
            <a href="/quienes-somos/">Quienes Somos</a>
            <a href="/contacto-colombia/">Contacto</a>
          </div>
        );
      }
      if(this.state.country === 'cl'){
        return (
          <div>
            <a href="/quienes-somos/">Quienes Somos</a>
            <a href="/contacto-chile/">Contacto</a>
          </div>
        );
      }
      if(this.state.country === 'cent'){
        return (
          <div>
            <a href="/quienes-somos/">Quienes Somos</a>
            <a href="/contacto-centro-america/">Contacto</a>
          </div>
        );
      }
      if(this.state.country === 'do'){
        return (
          <div>
            <a href="/quienes-somos/">Quienes Somos</a>
            <a href="/contacto-republica-dominicana/">Contacto</a>
          </div>
        );
      }
      if(this.state.country === 've'){
        return (
          <div>
            <a href="/quienes-somos/">Quienes Somos</a>
            <a href="/contacto-venezuela/">Contacto</a>
          </div>
        );
      }
      
      return (
          <div>
            <a href="/quienes-somos/">Quienes Somos</a>
            <a href="/contacto/">Contacto</a>
          </div>
        )
  }
}

function mapStateToProps (reducer){
  return {
    country: reducer.country
  }
}

function mapDispathToProps (dispatch){
  return {
    getLocation: (data) => dispatch(initLocation(data)),
  }
}

export default connect(mapStateToProps, mapDispathToProps)(Contact)



// WEBPACK FOOTER //
// ./src/contact.js